<template>
<div id="front_main" class="hidden-scroll">
    <!-- (메인) -->
    <div>
        <div class="reser_content">
            <div class="notice_box">
                <div id="front-main-content">
                    <div class="front-main-wrap">
                        <div class="main-banner-wrap">
                            <div class="main-banner">
                                <div v-bind:style="{background: `url('../../assets/image/7.png') no-repeat center center`}">
                                    <div class="main-banner-info">
                                        <!--<span class="main-banner-status" v-if="seat_using_chk || groom_using_chk">이용중</span>-->
                                        <div>
                                            <span class="main-banner-title" style="  overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{store_name}}</span>
                                            <br>
                                            <span class="main-banner-number">{{store_num}}</span>
                                        </div>
                                        <p class="main-banner-adress"></p>

                                        <!-- <p>24시간 영업<br>
                                            단체석, 주차, 예약,<br>
                                            무선인터넷, 남/녀 좌석 구분, 프린터, 복사기
                                        </p> -->
                                    </div>
                                </div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                        <div class="seat-status-wrap">
                            <div class="seat-status">
                                <div class="status-title">
                                    <span>개인석</span>
                                </div>
                                <div class="status-count">
                                    <span><em>{{empty_seat}}</em> / {{total_seat}}</span>
                                </div>
                            </div>
                            <div class="seat-status">
                                <div class="status-title">
                                    <span>사물함</span>
                                </div>
                                <div class="status-count">
                                    <span><em>{{empty_locker}}</em> / {{total_locker}}</span>
                                </div>
                            </div>
                            <div class="seat-status">
                                <div class="status-title">
                                    <span>그룹룸</span>
                                </div>
                                <div class="status-count">
                                    <span><em>{{empty_groom}}</em> / {{total_groom}}</span>
                                </div>
                            </div>
                        </div>
                        
                        <div class="main-menu-wrap">
                            <div class='main-menu-title'>
                                 상품선택
                            </div>
                            <div class='main-menu'>
                                <div class="menu-1" @click="move_page(1)">
                                    <img class = 'menu-img' src="../../assets/image/menubtn1.png" alt="menu_btn">
                                    <div class='side-text'>
                                        <div class='menu-title'>좌석/룸 선택</div>
                                        <div class='menu-sub-tilte'>원하시는 좌석을 확인하세요.</div>
                                    </div>
                                </div>
                                <div class="menu-2" @click="move_page(3)">
                                    <img class = 'menu-img' src="../../assets/image/menubtn2.png" alt="menu_btn">
                                    <div class='side-text'>
                                        <div class='menu-title'>상품리스트</div>
                                        <div class='menu-sub-tilte'>구매한 상품리스트를 보여줍니다.</div>
                                    </div>
                                </div>
                    
                                <div class="menu-3" @click="move_page(4)">
                                    <img class = 'menu-img' src="../../assets/image/menubtn3.png" alt="menu_btn">
                                    <div class='side-text'>
                                        <div class='menu-title'>마이페이지</div>
                                        <div class='menu-sub-tilte'>나의정보를 확인 가능합니다.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                
            </div>
        </div>
    </div>    
    <mypage hidden></mypage>
    <pop hidden></pop>
</div>
</template>

<script>
import vue from 'vue';
import mypage from '../page/mypage';
import seat from '../components/seat';
import pop from '../components/pop';
vue.component('mypage', mypage);
vue.component('seat', seat);
vue.component('pop', pop);
// 공통함수
import common from '@/assets/js/common.js';
// import jquery_barcode from '@/assets/js/jquery-barcode.js';
import html2canvas from '@/assets/js/html2canvas.min.js';
import VueBarcode from 'vue-barcode';
import Vue2TouchEvents from 'vue2-touch-events';
import { EventBus } from '../../main.js';

vue.use(Vue2TouchEvents);
vue.component('barcode', VueBarcode);

// 사용자 정의 모듈.
import * as config from '../../javascript/config';
// 좌석 / 사물함 / 그룹룸

export default {
    name: 'front_main',
    data() {
        return {
            total_seat: '',
            empty_seat: '',

            total_groom: '',
            empty_groom: '',

            total_locker: '',
            empty_locker: '',

            seat_using_chk: true,
            barcode_chk: false,
            groom_using_chk: false,
            user_id: '',
            user_name: '',
            store_id: '',
            store_name: '',
            store_num: '',

            seat_name: '',
            seat_type_name: '',
            seat_start_time: '',
            seat_end_time: '',
            seat_type_code: '',
            seat_status_code: '',

            groom_name: '',
            groom_start_time: '',
            groom_end_time: '',

            goods_seat_name: '',
            goods_groom_name: '',
            goods_group_name: '',

            info: 'seat',
            barcodeValue: [{barcode_code:''},{barcode_code:''}],
            popup_code: 0,

            map_img: '',
            map_group_id: '',
            background_data: '',
            tab_index: '',
            // from_pop: true,
            from_fornt_pop: true,

            move_seat_name: '',
            move_seat_id: '',
            sel_seat_use_id: '',
            sel_seat_id: '',
            front_seat_use_id: "",
            front_seat_id: "",
            front_goods_end_datetime: "",
            seat_left_time: "",
            time_goods_flag: 0,
            // 연장사용시간 계획 컬럼 추가 2020.11.29 cjb
            continue_use_hours_plan: "",
            total_sum_end_date: "", // 종료시간과 연장시간 합친 값 추가 2020.11.29 cjb

            continue_seat_purchase_history_flag: false,
            store_info_data: {},    
        }

    },
    methods: {        
        seat_move_res(code, data) {
            if (code == 5) {
                //this.popup_code = 0; // 스마트 출입에서 자리이동시 자리이동 팝업 떠도 백그라운드에 좌석배치도 보이도록 수정함, 해당 부분만 주석처리 하면 됨 2020.11.30 cjb
            }
        },
        close_pop() {
            this.popup_code = 0;
        },
        floor_tab(item, index) {
            this.map_img = config.SYS_HOST + `/images/kiosk/${item.map_img}`;
            this.map_group_id = item.map_group_id;
            this.background_data = item;
            this.tab_index = index;
        },
        move_seat() {
            this.tab_data = this.$store.getters['get_map_group_list'];
            this.floor_tab(this.tab_data[0], 0);
            this.popup_code = 21;
            return;
        },
        end_seat() {
            const main_type = config.REQ_SEAT_MAIN_TYPE;
            const data = {
                data: {
                    seat_id: this.front_seat_id,
                    store_id: this.store_id
                }
            };
            this.$store.dispatch(main_type.action_name, {
                type: main_type,
                data: data
            }).then(response => {
                // response[0].main_seat_type_code = 'FIXED';
                if (response[0].main_seat_type_code == 'FIXED') {
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_CHECK_OUT_TEXT,
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    return;
                } else {
                    var end = new Date(this.seat_end_time);
                    var _second = 1000;
                    var _minute = _second * 60;
                    var _hour = _minute * 60;
                    var _day = _hour * 24;
                    var timer;

                    var now = new Date();

                    var distance = end - now + _minute;

                    var days = Math.floor(distance / _day);
                    var hours = Math.floor((distance % _day) / _hour);
                    var minutes = Math.floor((distance % _hour) / _minute);
                    var seconds = Math.floor((distance % _minute) / _second);

                    var strDays = days.toString();
                    var strHours = hours.toString();
                    var strMin = minutes.toString();
                    var strSec = seconds.toString();

                    this.seat_left_time = strDays + '일' + ' ' + strHours + '시간' + ' ' + strMin + '분';
                    //종료 5분전 체크 로직
                    var end_5 = new Date(this.seat_end_time);
                    var end_y = end_5.getFullYear();
                    var end_m = end_5.getMonth() + 1;
                    var end_d = end_5.getDate();
                    var end_h = end_5.getHours();
                    var end_mm = end_5.getMinutes();

                    var today_5 = new Date();
                    var today_y = today_5.getFullYear();
                    var today_m = today_5.getMonth() + 1;
                    var today_d = today_5.getDate();
                    var today_h = today_5.getHours();
                    var today_mm = today_5.getMinutes();
                    if (end_y == today_y && end_m == today_m && end_d == today_d && end_h == today_h) {
                        let left_time = end_mm - today_mm;
                        if (left_time <= 5) {
                            const alert_param = {
                                code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                                message: `상품 만료시간 5분전에는<br>종료 할 수 없으며,<br>5분 후 자동 종료 처리<br> 됩니다.`,
                                router: '',
                            };
                            this.$store.commit('set_popup_type', alert_param);
                            return;
                        }
                    }
                    // 보여줄 팝업 의 팝업코드 삽입 - 이용종료 code = 7
                    this.popup_code = 7;
                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });

        },
        seat_use_end() {
            const type = config.REQ_SEAT_USE_DELETE;
            const request_data = {
                'data': {
                    'seat_use_id': this.front_seat_use_id,
                    'seat_id': this.front_seat_id
                }
            };
            this.$store.dispatch(type.action_name, {
                type: type,
                data: request_data
            }).then(response => {
                if (response.message == "complete") {
                    this.close_pop();
                    this.main_data_setting();
                    this.barcode_updown();
                }

            }).catch(function (error) {
                console.log('error=============>', error);
            });
        },
        use_extension() {
            this.$store.commit('set_select_seat', {
                seat_id: this.front_seat_id,
                seat_name: this.seat_name,
                seat_type_code: this.seat_type_code,
                seat_type_name: this.seat_type_name,
                seat_status_code: this.seat_status_code
            });
            var store_pay_info = this.$store.getters['getStore_pay_info'];
            if (store_pay_info) {
                
                this.$store.commit('setExtention_flag', {
                    value: true
                });

                this.$router.push('/payment-seat');
            } else {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_SEAT_USE_PRODUCT_COUPON_LIST,
                }
                this.$store.commit('set_popup_type', alert_param);
            }

        },
        barcode_updown() {
            var goods_name = this.$store.getters['getGoods_name'];
            this.goods_seat_name = goods_name.using_seat_goods_name;
            this.goods_groom_name = goods_name.using_groom_goods_name;
            this.barcode_chk = !this.barcode_chk;
            // 바코드     
        },
        barcode_info_change(type) {
            document.getElementById('barcode_' + this.info).classList.remove('on');
            this.info = type;
            document.getElementById('barcode_' + type).classList.add('on');
        },
        move_page(Num) {
            if (Num == 1) {
                this.$router.push('/');
            } else if (Num == 3) {
                this.$router.push('/price_list');
            } else if (Num == 4) {
                this.$router.push('/mypage');
            } else {
                this.$router.push('/');
            }
            EventBus.$emit('route_change', Num);

        },
        main_data_setting() {
            const type = config.REQ_ITEM_CURRENT_SITUATION_GET; // 현재 좌석현황 체크 데이터 조회
            const req_data = {};
            this.$store.dispatch(type.action_name, {
                type: type,
                data: req_data
            }).then(response => {
                this.total_seat = response[0].free_seat_count + response[0].fixed_seat_count;
                this.empty_seat = response[0].fixed_seat_available + response[0].free_seat_available;
                this.total_groom = response[0].groom_count;
                this.empty_groom = response[0].groom_available;
                this.total_locker = response[0].locker_count;
                this.empty_locker = response[0].locker_available;

            }).catch(function (error) {
                console.log('error=============>', error);
            });
            const type_seat = config.REQ_SEAT_USE_GET_LIST; // 현재 이용중인 상품정보 노출
            const data_seat = {};
            this.$store.dispatch(type.action_name, {
                type: type_seat,
                data: data_seat
            }).then(response => {
                if (response.data.length > 0) {
                    if (response.data[0].day_count == null) {
                        this.time_goods_flag = 1
                    } else {
                        this.time_goods_flag = 0
                    }
                    if (response.data[0].continue_seat_purchase_history_id != null) {
                        this.continue_seat_purchase_history_flag = true;
                    } else {
                        this.continue_seat_purchase_history_flag = false;
                    }
                    this.seat_using_chk = true;
                    this.seat_name = response.data[0].seat_name;
                    this.seat_start_time = response.data[0].use_start_datetime;
                    this.seat_end_time = response.data[0].use_end_datetime;
                    this.seat_type_name = response.data[0].seat_type_name;
                    this.seat_type_code = response.data[0].seat_type_code;
                    this.seat_status_code = response.data[0].seat_status_code;
                    this.front_seat_use_id = response.data[0].seat_use_id;
                    this.front_seat_id = response.data[0].seat_id;
                    this.front_goods_end_datetime = response.data[0].goods_end_datetime;
                    this.continue_use_hours_plan = response.data[0].continue_use_hours_plan; // 연장사용시간계획 추가조회 2020.11.29 cjb
					

                    let sumDate = new Date(this.seat_end_time);
                    let sum_total_date = sumDate.setMinutes(sumDate.getMinutes() + this.continue_use_hours_plan);
                    
                    let tDate = new Date(sum_total_date);

					let dd = tDate.getDate();
                    let mm = tDate.getMonth() + 1; //January is 0!
                    let yyyy = tDate.getFullYear();
                    let hour = tDate.getHours();
                    let min = tDate.getMinutes();
                    if (hour < 10) {
                        hour = '0' + hour;
                    }
                    if (min < 10) {
                        min = '0' + min;
                    }

                    if (dd < 10) {
                        dd = '0' + dd;
                    }
                    if (mm < 10) {
                        mm = '0' + mm;
                    }
                    let currentTime = hour + ":" + min + "";
                    this.total_sum_end_date = yyyy + '-' + mm + '-' + dd + ' ' + currentTime;

					
                    this.$store.commit('set_my_seat_data', {
                        seat_id: this.front_seat_id,
                        seat_name: this.seat_name,
                        seat_use_id: this.front_seat_use_id,
                        use_start_datetime: this.seat_start_time,
                        use_end_datetime: this.seat_end_time,
                        // 연장사용시간계획 추가조회 2020.11.29 cjb
                        continue_use_hours_plan: this.continue_use_hours_plan,
                        goods_end_datetime: this.front_goods_end_datetime,
                        left_time: response.data[0].left_time,
                        use_total_time: response.data[0].use_total_time,
                        map_group_id: this.map_group_id,
                        main_seat_type_code: null,
                        total_sum_end_date: this.total_sum_end_date,

                    });


                } else {
                    this.seat_using_chk = false;
                }
                this.$store.commit('setFor_pop_txt', this.seat_using_chk);

            }).catch(function (error) {
                console.log('error=============>', error);
            });
            var user_info = this.$store.getters['getUser'];
            var store_info = this.$store.getters['getStoreInfo'];
            this.store_name = store_info.store_name;
            this.store_num = store_info.store_tel_number;
            this.store_id = user_info.store_id;
            this.user_id = user_info.user_id;
            this.user_name = user_info.name;

            const myproduct_list_type = config.REQ_GROOM_USE_CHECK;
            const data_groom = {};
            this.$store.dispatch(type.action_name, {
                type: myproduct_list_type,
                data: data_groom
            }).then(response => {
                for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].user_id == this.user_id) {
                        this.groom_name = response.data[i].groom_name;
                        this.groom_start_time = response.data[i].use_start_datetime;
                        this.groom_end_time = response.data[i].use_end_datetime;
                        this.goods_group_name = response.data[i].goods_group_name;
                        this.groom_using_chk = true;
                    }
                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });

            const barcode_type = config.REQ_GET_BARCODE_INFO;
            const data_barcode = {
                store_id: this.store_id,
                user_id: this.user_id
            };
            this.$store.dispatch(type.action_name, {
                type: barcode_type,
                data: data_barcode
            }).then(response => {
                if (response.result) {
                    if (response.data.length != 0) {
                        for(let i=0;i<response.data.contents.length;i++){
                            if(response.data.contents[i].barcode_type_code == "BARCODE_SEAT"){
                                this.$store.commit('set_seat_barcode', response.data.contents[i].barcode_code );
                            }
                            if(response.data.contents[i].barcode_type_code == "BARCODE_GROOM"){
                                this.$store.commit('set_groom_barcode', response.data.contents[i].barcode_code );
                            }
                        }
                    }
                }
                this.barcodeValue = response.data.contents;
            }).catch(function (error) {
                console.log('error=============>', error);
            });
        },
        get_seat_type_color_count() {
            const type = config.REQ_SEAT_USER_GET_TYPE_COLOR_LIST;
            const req_data = {
                map_group_id: this.map_group_id
            };
            this.$store.dispatch(type.action_name, {
                type: type,
                data: req_data
            }).then(response => {
                this.$store.commit('set_seat_type_color', response.data);
                this.seat_type_color = response.data
            }).catch(function (error) {
                console.log('error=============>', error);
            });
        },
        getStoreOption(){
            const type = config.REQ_STORE_OPTION
            this.$store.dispatch(type.action_name, {
                type: type,
                store_id: this.store_info_data.store_id
            }).then((response) => {
                this.$store.commit('set_store_option', response.data);
            }).catch(function (error) {
                console.log('error=============>', error)
            })
        },
    },
    computed: {
        get_seat_move_flag() {
            return this.$store.getters.get_seat_move_flag;
        },
    },
    watch: {
        map_group_id() {
            this.get_seat_type_color_count();
        },
        get_seat_move_flag(val, OldVal) {
            this.main_data_setting();
        },  
    },
    mounted() {
        this.$nextTick(function () {
            this.main_data_setting();
            this.store_info_data = this.$store.getters['getStoreInfo'];
            this.getStoreOption();
            //  로그인 체크 20211006 added
            if(this.store_info_data.user_id == undefined || this.store_info_data.user_id == ""){
                this.$router.push('/start');
            } 
            //    const alert_param = {
            //             code: 175
            //     };
            //     this.$store.commit('set_popup_type', alert_param)            
        });

    },

}
</script>


// WEBPACK FOOTER //
// src/components/page/front_main.vue